// extracted by mini-css-extract-plugin
export default {"row":"BottomDescList_row__EO2IV","col":"BottomDescList_col__XimJn","tit":"BottomDescList_tit__21SM-","desc":"BottomDescList_desc__PZv7F"};